import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';

import {
  SpaceSelectorTextContainer,
  SpaceSelectorSecondaryText,
  SpaceSelectorPrimaryText,
  ActivityIndicator,
  SelectorItem,
  ListItem,
  Avatar,
} from './SpaceSelectorItem.styled';

import { ENTER } from '../../../../../utils/keyCodes';

const SHOW_TOOLTIP_THRESHOLD = 17;

const listItemClasses = { text: 'listItemText' };

const SpaceSelectorItem = ({
  avatar,
  name,
  archived,
  hasActivity,
  onClick,
  ...props
}) => {
  const TooltipComponent =
    name.length >= SHOW_TOOLTIP_THRESHOLD ? Tooltip : React.Fragment;
  return (
    <TooltipComponent position="right" title={name}>
      <ListItem
        size="medium"
        textTruncate
        leftDecoration={<Avatar size="large" name={name} src={avatar} />}
        rightDecoration={hasActivity ? <ActivityIndicator /> : null}
        primaryText={
          <SpaceSelectorTextContainer>
            <SpaceSelectorPrimaryText>{name}</SpaceSelectorPrimaryText>
            <SpaceSelectorSecondaryText>
              {archived && 'Archived'}
            </SpaceSelectorSecondaryText>
          </SpaceSelectorTextContainer>
        }
        classes={listItemClasses}
        css={SelectorItem}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.keyCode === ENTER) {
            onClick();
          }
        }}
        data-testid="space-selector-item"
        {...props}
      />
    </TooltipComponent>
  );
};

SpaceSelectorItem.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string.isRequired,
  archived: PropTypes.bool,
  hasActivity: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

SpaceSelectorItem.defaultProps = {
  archived: false,
  avatar: '',
};

export default React.memo(SpaceSelectorItem);
